module.exports = __webpack_public_path__ + "static/img/interpretive-content-development.080be1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/creative-services/interpretive-content-development.jpg
// module id = 418
// module chunks = 0